export default {
  mock: {
    config: {},
    headers: {},
    status: 200,
    statusText: '',
    data: {
      tenantId: "tenants002",
      name: "アイラ株式会社",
      nameKana: "xxxxxx",
      address: "xxxxxx",
      sectionName: "地域サポート部門",
      staffName: "どい",
      tel: "xxxxxx",
      email: "xxxxxx",
      note: "xxxxxx",
      status: 1,
      communityCount: 2,
      createdAt: 1594880785395,
      updatedAt: 1594880785395
    }
  }
}